import MobileTabsHeader from 'components/TabsHeader/MobileTabsHeader';
import { usePerms } from 'contexts/PermsContext';
import DeviceSettings from 'features/integrations/features/ConnectedDevices/components/DeviceSettings.jsx';
import ConnectedDevices from 'pages/System/Integrations/ConnectedDevices/ConnectedDevices';
import { createContext, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import TabsHeader from '../../components/TabsHeader/TabsHeader';
import RescAlertDevicesWidget from './RescAlertDevicesWidget';

export const ConnectionsContext = createContext({});

const topTabs = [
  { option: 'Connected Systems' },
  { option: 'Connected Devices' },
  { option: 'Connected Device Groups' },
];

export default function Connections({ widget = false, widgetParams }) {
  const [searchParams] = useSearchParams();
  const perms = usePerms();
  const [visibleDeviceTypes, setVisibleDeviceTypes] = useState({
    Stage: true,
    'Manual Road Closure': true,
    'Technology Bridge_Flashing Lights': true,
    'Technology Bridge_Siren/Giant Voice': true,
  });

  const canViewDeviceType = (device) => {
    switch (device.device_type) {
      case 'Stage':
        return (
          perms.testPermission([8, 9, 10, 11, 12, 13], ['ViewFloodStageConnections']) &&
          visibleDeviceTypes['Stage']
        );
      case 'Stage':
        return (
          perms.testPermission([8, 9, 10, 11, 12, 13], ['ViewFloodStageConnections']) &&
          visibleDeviceTypes['Stage']
        );
      case 'Manual Road Closure':
        return (
          perms.testPermission(
            [8, 9, 10, 11, 12, 13],
            ['ViewRescAlertDevicesManualRoadClosureConnections'],
          ) && visibleDeviceTypes['Manual Road Closure']
        );
      case 'Technology Bridge_Flashing Lights':
        return (
          perms.testPermission(
            [8, 9, 10, 11, 12, 13],
            ['ViewRescAlertDevicesTechnologyBridge_FlashingLightsConnections'],
          ) && visibleDeviceTypes['Technology Bridge_Flashing Lights']
        );
      case 'technology Bridge_Siren/Giant Voice':
        return (
          perms.testPermission(
            [8, 9, 10, 11, 12, 13],
            ['ViewRescAlertDevicesTechnologyBridge_Siren-GiantVoiceConnections'],
          ) && visibleDeviceTypes['Technology Bridge_Siren/Giant Voice']
        );
      case 'Monitoring Station':
        return (
          perms.testPermission([8, 9, 10, 11, 12, 13], ['ViewUSGSMonitoringStationConnections']) &&
          visibleDeviceTypes['Monitoring Station']
        );
      default:
        return true;
    }
  };

  const renderTab = () => {
    switch (searchParams.get('tab')?.toLowerCase()) {
      case 'connected devices':
        return <ConnectedDevices />;
      case 'connected device groups':
      // return <DeviceGroups />;
      default:
        return <div />;
    }
  };

  if (widget) {
    switch (widgetParams.widgetType) {
      case 'map':
        return (
          <ConnectionsContext.Provider
            value={{
              canViewDeviceType,
              visibleDeviceTypes,
              setVisibleDeviceTypes,
            }}
          >
            <ConnectedDevices
              sidebarOpen={widgetParams.sidebarOpen}
              widgetType={widgetParams.widgetType}
              dimensions={widgetParams.dimensions}
              preview={widgetParams.preview}
              widget
            />
          </ConnectionsContext.Provider>
        );
      case 'graph':
        return (
          <ConnectionsContext.Provider
            value={{
              canViewDeviceType,
              visibleDeviceTypes,
              setVisibleDeviceTypes,
            }}
          >
            <ConnectedDevices
              sidebarOpen={widgetParams.sidebarOpen}
              widgetType={widgetParams.widgetType}
              dimensions={widgetParams.dimensions}
              preview={widgetParams.preview}
              widget
            />
          </ConnectionsContext.Provider>
        );

      case 'technologyBridge': {
        return (
          <ConnectionsContext.Provider
            value={{
              canViewDeviceType,
              visibleDeviceTypes,
              setVisibleDeviceTypes,
            }}
          >
            <RescAlertDevicesWidget
              type="technologyBridge"
              sidebarOpen={widgetParams.sidebarOpen}
              dimensions={widgetParams.dimensions}
              nested={widgetParams.nested}
              deviceForWidget={widgetParams.deviceForWidget}
            />
          </ConnectionsContext.Provider>
        );
      }

      case 'manualRoadClosure':
        return (
          <ConnectionsContext.Provider
            value={{
              canViewDeviceType,
              visibleDeviceTypes,
              setVisibleDeviceTypes,
            }}
          >
            <RescAlertDevicesWidget
              type="manualRoadClosure"
              sidebarOpen={widgetParams.sidebarOpen}
              dimensions={widgetParams.dimensions}
              nested={widgetParams.nested}
              deviceForWidget={widgetParams.deviceForWidget}
            />
          </ConnectionsContext.Provider>
        );

      case 'technologyBridgeSiren':
        return (
          <ConnectionsContext.Provider
            value={{
              canViewDeviceType,
              visibleDeviceTypes,
              setVisibleDeviceTypes,
            }}
          >
            <RescAlertDevicesWidget
              type="technologyBridgeSiren"
              sidebarOpen={widgetParams.sidebarOpen}
              dimensions={widgetParams.dimensions}
              nested={widgetParams.nested}
              deviceForWidget={widgetParams.deviceForWidget}
            />
          </ConnectionsContext.Provider>
        );

      case 'list':
      case 'connectedDevicesList':
        return (
          <ConnectionsContext.Provider
            value={{
              canViewDeviceType,
              visibleDeviceTypes,
              setVisibleDeviceTypes,
            }}
          >
            <ConnectedDevices
              sidebarOpen={widgetParams.sidebarOpen}
              widgetType="list"
              dimensions={widgetParams.dimensions}
              preview={widgetParams.preview}
              widget
            />
          </ConnectionsContext.Provider>
        );

      case 'overwatchVMS':
        return (
          <ConnectionsContext.Provider
            value={{
              canViewDeviceType,
              visibleDeviceTypes,
              setVisibleDeviceTypes,
            }}
          >
            <DeviceSettings device={widgetParams.deviceForWidget} widget={true} />
          </ConnectionsContext.Provider>
        );
      default:
        return <div></div>;
    }
  }

  return (
    <div className="h-100">
      {/* header */}
      <div className="d-none d-lg-block">
        <TabsHeader options={topTabs} />
      </div>
      <div className="d-block d-lg-block">
        <MobileTabsHeader options={topTabs} />
      </div>
      {/* content */}
      <div
        style={{
          height: 'calc(100% - 44px)',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <ConnectionsContext.Provider
          value={{
            canViewDeviceType,
            visibleDeviceTypes,
            setVisibleDeviceTypes,
          }}
        >
          {renderTab()}
        </ConnectionsContext.Provider>
      </div>
    </div>
  );
}
